import React, { useEffect, useState } from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { Formik } from "formik";
import FormField from "../../schedules/FormInputs";
import { PrimaryCTAButton } from "../../common/Buttons";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import { Header } from "../Header/Header";
import { navigate, useLocation } from "@reach/router";
import "./index.css";
import Footer from "../../Viewer/Header/Footer";
import useViewer from "../../../hooks/useViewer";
// import MenuBurger from "../../common/ActionBar/MenuBurger";
import { getErrorMessage } from "../../../helpers/functions";
//import { HeadingContainer, Header3 } from "../../../styles/component/style";
import { desiredOrder } from "../../../helpers/constants";
import FAQs from "../../schedules/MenuBar/Faqs";

const GalleryViewRegister = (props) => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [arrayOfObject, setArrayOfObject] = useState();
  const { setToken, setGlobalState } = useViewer();
  const [inputs, setInputs] = useState([]);
  const location = useLocation();

  const params = new URLSearchParams(window.location.search);

  const eventId = params.get("eventId");

  const excludedKeys = [
    "galleryViewUrl",
    "enableGalleryView",
    "showFooter",
    "showHeader",
  ];

  useEffect(() => {
    async function getRegister() {
      try {
        localStorage.removeItem("image");
        setLoader({ state: true, message: "please wait..." });
        const response = await EventService.getRegister(eventId);
        setArrayOfObject(response);
        setGlobalState(response);
        localStorage.setItem(
          "image",
          response?.theme?.themeGeneral?.backgroundImage,
        );
        if (response?.galleryView !== null && response?.galleryView) {
          if (Object.keys(response?.galleryView).length !== 0) {
            const orderedArray = desiredOrder
              .filter(
                (key) =>
                  !excludedKeys.includes(key) &&
                  response.galleryView[key] === true,
              )
              .map((key) => ({
                name: key,
                type: "text",
                label: key
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, (str) => str.toUpperCase()), // Convert camelCase to spaced words
                placeholder: `Enter your ${key
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, (str) => str.toUpperCase())}`,
                labelHidden: response?.eventSettings?.labelsOutside
                  ? false
                  : true,
              }));
            setInputs([...orderedArray]);
          }
        }
        if (response?.eventTemplate !== "AGM") {
          navigate(`/events/register?eventId=${eventId}`);
        }
      } catch (err) {
        enqueueSnackbar(err?.message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
      }
    }
    getRegister(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (eventId) {
      const interval = setInterval(() => {
        (async function getRegister() {
          try {
            const response = await EventService.getRegister(eventId);
            setArrayOfObject(response);
            setGlobalState(response);
            localStorage.setItem(
              "image",
              response?.theme?.themeGeneral?.backgroundImage,
            );
            if (response?.galleryView !== null && response?.galleryView) {
              if (Object.keys(response?.galleryView).length !== 0) {
                const orderedArray = desiredOrder
                  .filter(
                    (key) =>
                      !excludedKeys.includes(key) &&
                      response.galleryView[key] === true,
                  )
                  .map((key) => ({
                    name: key,
                    type: "text",
                    label: key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase()), // Convert camelCase to spaced words
                    placeholder: `Enter your ${key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}`,
                    labelHidden: response?.eventSettings?.labelsOutside
                      ? false
                      : true,
                  }));
                setInputs([...orderedArray]);
              }
            }
          } catch (err) {
            enqueueSnackbar(err?.message, {
              variant: "error",
            });
          }
        })();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [eventId]); // eslint-disable-line react-hooks/exhaustive-deps

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = { ...values };
      const response = await EventService.galleryLogin(
        arrayOfObject?.eventId,
        payload,
      );
      if (response) {
        enqueueSnackbar("Registration success.", {
          variant: "success",
        });
        localStorage.setItem("role", "eventviewer");
        localStorage.setItem("auth_token", response.token);
        navigate("/gallery-viewer-live#home");
        setToken(response.token);
      }
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const getKeys = () => {
    let objctKeys = {};

    inputs.map((item) => (objctKeys[item.name] = ""));
    return { ...objctKeys };
  };

  /*

  const actions = [
    {
      text: "Home",
      props: {
        onClick: () => {
          navigate(`/events/register?eventId=${eventId}#home`);
        },
      },
    },
    {
      text: "FAQs",
      props: {
        onClick: () => {
          navigate("#faqs");
        },
      },
    },
    {
      text: "Help",
      props: {
        onClick: () => {
          navigate("#help");
        },
      },
    },
  ];

  */

  return (
    <>
      <Layout
        image={arrayOfObject?.theme?.themeGeneral?.backgroundImage}
        bgColor={arrayOfObject?.theme?.themeGeneral?.bodyBackgroundColor}
      >
        <Header
          showHeader={arrayOfObject?.galleryView?.showHeader}
          registration={arrayOfObject?.galleryView?.showHeader ? true : false}
        >
          {/* {arrayOfObject?.theme?.themeNavigationBar?.navBarTreatment ===
            "alwaysVisible" && (
            <MenuBurger
              {...{ actions }}
              color={
                arrayOfObject?.theme?.themeNavigationBar?.menuButtonTextColor
              }
              hoverColor={
                arrayOfObject?.theme?.themeNavigationBar?.menuButtonHoverColor
              }
              menuBackgroundColor={
                arrayOfObject?.theme?.themeNavigationBar?.menuButtonBgColor
              }
              activeMenuButtonBgColor={
                arrayOfObject?.theme?.themeNavigationBar
                  ?.activeMenuButtonBgColor
              }
              activeMenuButtonTextColor={
                arrayOfObject?.theme?.themeNavigationBar
                  ?.activeMenuButtonTextColor
              }
            />
          )} */}
          {arrayOfObject?.eventTemplate !== "AGM" ? (
            <WidthMax id="about">
              {arrayOfObject?.eventTitle ? (
                <DrawerContainer>
                  <h2>Gallery View not available for this event</h2>
                </DrawerContainer>
              ) : null}
            </WidthMax>
          ) : arrayOfObject?.eventTemplate === "AGM" &&
            !arrayOfObject?.galleryView?.enableGalleryView ? (
            <WidthMax id="about">
              {arrayOfObject?.eventTitle ? (
                <DrawerContainer>
                  <h2>Gallery View is not enable for this event</h2>
                </DrawerContainer>
              ) : null}
            </WidthMax>
          ) : (arrayOfObject?.registrationStatus === "open" &&
            arrayOfObject?.eventStatus === "active") ||
            (arrayOfObject?.registrationStatus === "open" &&
              arrayOfObject?.eventStatus === "inactive") ? (
            <WidthMax
              id="about"
              style={{
                marginTop: "0px",
              }}
            >
              {location.href.includes("faqs") ? (
                <FAQs data={arrayOfObject?.faq} />
              ) : location.href.includes("help") ? (
                <FAQs data={arrayOfObject?.help} help={true} />
              ) : (
                <HeroContainerWrap id="hero">
                  <HeroContainer>
                    <Formik
                      initialValues={getKeys()}
                      enableReinitialize
                      onSubmit={onFormSubmit}
                      validationSchema={""}
                      validateOnBlur
                      validateOnChange
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleBlur,
                        handleSubmit,
                        handleChange,
                        resetForm,
                        setFieldValue,
                      }) => (
                        <Container
                          display={
                            arrayOfObject?.standardField
                              ?.registrationformPosition
                          }
                        >
                          <RegisterContainer
                            className={
                              arrayOfObject?.standardField
                                ?.registrationformPosition === "left"
                                ? "start-center"
                                : arrayOfObject?.standardField
                                  ?.registrationformPosition === "right"
                                  ? "end-center"
                                  : "middle-center"
                            }
                          >
                            {/* <HeadingContainer>
                              <Header3
                                style={{
                                  marginBottom: "15px",
                                  color:
                                    arrayOfObject?.theme?.themeGeneral
                                      ?.titleTextColor,
                                  fontFamily:
                                    arrayOfObject?.theme?.themeGeneral
                                      ?.titleTextFont,
                                  fontSize: `${arrayOfObject?.theme?.themeGeneral?.titleTextFontSize}px`,
                                }}
                              >
                                {arrayOfObject?.eventTitle}
                              </Header3>
                            </HeadingContainer> */}
                            <form style={{ width: "100%" }}>
                              <Grid grid={inputs.length}>
                                {inputs.map((item, index) => {
                                  return (
                                    <FormField
                                      key={index}
                                      {...{
                                        touched,
                                        errors,
                                        item,
                                        values,
                                        handleChange,
                                        handleBlur,
                                        setFieldValue,
                                      }}
                                      name={item.name}
                                      value={values[item.name]}
                                    />
                                  );
                                })}
                              </Grid>
                              <div style={{ textAlign: "center" }}>
                                <PrimaryCTAButton
                                  style={{ width: "auto", marginTop: "10px" }}
                                  disabled={
                                    arrayOfObject?.eventSettings
                                      ?.enableLogins &&
                                    !arrayOfObject?.eventSettings
                                      ?.enableRegistration &&
                                    !arrayOfObject?.preValidateUsers
                                      ?.preValidateRegistration
                                  }
                                  onClick={handleSubmit}
                                >
                                  Register
                                </PrimaryCTAButton>
                              </div>
                            </form>
                          </RegisterContainer>
                        </Container>
                      )}
                    </Formik>
                  </HeroContainer>
                </HeroContainerWrap>
              )}
            </WidthMax>
          ) : arrayOfObject?.registrationStatus === "closed" &&
            arrayOfObject?.eventStatus === "inactive" ? (
            <WidthMax id="about">
              <DrawerContainer>
                {(arrayOfObject?.playbackInfo?.playbackRequired &&
                  !arrayOfObject?.playbackInfo?.playbackVideo?.length) ||
                  (arrayOfObject?.playbackInfo?.playbackRequired &&
                    arrayOfObject?.playbackInfo?.playbackVideo?.length) ? (
                  <h2>
                    {arrayOfObject?.eventStatus
                      ? "Event status is Inactive / Registration Closed"
                      : null}
                  </h2>
                ) : (
                  <h2>
                    {arrayOfObject?.eventStatus
                      ? "Event status is Inactive / Registration Closed "
                      : null}
                  </h2>
                )}
              </DrawerContainer>
            </WidthMax>
          ) : arrayOfObject?.registrationStatus === "closed" &&
            arrayOfObject?.eventStatus === "active" ? (
            <div style={{ textAlign: "center" }}>
              <WidthMax id="about">
                <DrawerContainer>
                  <h2>
                    {arrayOfObject?.eventStatus
                      ? "Event status is active / Registration Closed "
                      : null}
                  </h2>
                </DrawerContainer>
              </WidthMax>
            </div>
          ) : null}
          {arrayOfObject?.galleryView?.showFooter && <Footer />}
        </Header>
      </Layout>
    </>
  );
};

export default GalleryViewRegister;

export const Grid = styled.div`
  border-radius: 10px;
  @media ${theme?.breakpoints?.sm_up} {
    padding: 0;
    border-radius: 0;
    background-color: transparent;
  }
`;

const RegisterContainer = styled.div`
  width: 480px;
  height: auto;
  max-height: 75vh;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  background-color: rgba(255, 255, 255, 0.8);
  // opacity: 0.5;
  jsutify-content: center;
  padding: 20px;
 // margin-top: 50px;
 // margin-bottom: 50px;
  position:fixed;
  overflow-y:scroll;
    &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */
`;

const Container = styled.div`
  display: flex;
  justify-content: ${({ display }) =>
    display === "left"
      ? "flex-right"
      : display === "right"
        ? "flex-end"
        : "center"};
  align-items: center;
  position: relative;
  
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75vh; // Full viewport height
  padding: 20px;
  width:100%;
`;

export const WidthMax = styled.div`
  width: 100vw;
  min-height: 100vh;
`;

export const HeroContainerWrap = styled.section`
  width: 100%;
  height: 100%;
`;

export const HeroContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  & .hero-container {
    width: 100%;
    height: 100%;
    & .hero-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.8;
    }
  }
`;

export const Layout = styled.div`
  max-height: 100vh;
  height: 100%;
  overflow-y: scroll;
  scrollbar-width: none;
  background: ${({ image, bgColor }) =>
    image ? `url(${image}) no-repeat center center` : bgColor};
  background-size: cover;
`;

export const DrawerContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: Poppins, sans-serif;
  color: #d91b1b;
`;